import { ImageCoverView, View } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { Match2DailyChallengeId } from 'src/replicant/match2/dailychallenge/match2-dailychallenge.ruleset';
import Match2ProgressBar from '../components/Match2ProgressBar';
import { getDailyChallengeObjectiveIcon } from '../match2.icons';

export default class Match2DailyChallengeBar extends Match2ProgressBar {
  private objectiveIcon: ImageCoverView;
  private progressText: LangBitmapFontTextView;
  private _current = 0;
  private requirement = 0;

  constructor({
    superview,
    width = 380,
    x = 0,
    y = 0,
    scale = 1,
  }: {
    superview: View;
    width?: number;
    x?: number;
    y?: number;
    scale?: number;
  }) {
    super({
      superview,
      width,
      height: 58,
      x,
      y,
      scale,
    });

    this.updateOpts({ anchorY: 29 });

    this.progressText = new LangBitmapFontTextView({
      superview: this,
      font: 'Title',
      color: '#FFFFFF',
      size: 25,
      x: this.style.width * 0.5,
      y: 12,
      centerOnOrigin: true,
      centerAnchor: true,
      align: 'center',
      verticalAlign: 'center',
    });

    this.objectiveIcon = new ImageCoverView({
      superview: this,
      width: 86,
      height: 80,
      mode: 'contain',
      centerOnOrigin: true,
      centerAnchor: true,
      x: 15,
      y: this.style.height * 0.5 - 4,
    });
  }

  public set current(v: number) {
    this._current = v;
    this.refresh();
  }

  public get current() {
    return this._current;
  }

  public setObjective(id: Match2DailyChallengeId) {
    getDailyChallengeObjectiveIcon(id)
      .get()
      .then((img) => {
        this.objectiveIcon.setImage(img);
      });
  }

  public setRequirement(v: number) {
    this.requirement = v;
    this.refresh();
  }

  private refresh() {
    const current = Math.min(this.current, this.requirement);
    this.progress = current / this.requirement;
    if (!this.progressText) return;
    this.progressText.text = `${Math.round(current)}/${this.requirement}`;
  }
}
